import {
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material';
import { handlePageAnalytics } from 'Common/analytics';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';
import React, { ReactNode } from 'react';
import theme, { BrandColors } from './common/theme';
import { NavOption } from 'src/scripts/content';
import Container from '@mui/material/Container';
import DevSiteBanner from 'src/scripts/layout/other/DevSiteBanner';
import ActivateUserModal from 'src/scripts/layout/other/ActivateUserModal';
import LeftNav from 'src/scripts/layout/left-nav/LeftNav';
import { Footer } from 'Common/common-ui';
import AppHeader from 'src/scripts/layout/header/AppHeader';
import { styled } from '@mui/material/styles';
import { isSmallScreen } from 'Common/util';

interface Props {
  navOptions: NavOption;
  children: ReactNode;
}

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: BrandColors.DarkGray,
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: '#970C0C',
  },
}));

export default function AppBase(props: Props) {
  handlePageAnalytics();
  const smallScreen = isSmallScreen();
  const [open, setOpen] = React.useState(!smallScreen);

  function toggleLeftNav(): void {
    setOpen(!open);
  }

  return (
    <StyledEngineProvider injectFirst>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          Components={{
            success: StyledMaterialDesignContent,
            error: StyledMaterialDesignContent,
          }}
          maxSnack={3}
          autoHideDuration={3000}
          classes={{
            anchorOriginBottomCenter: 'snackbar-bottom-center',
            anchorOriginTopRight: 'snackbar-top-right',
            root: 'snackbar-root',
          }}
        >
          <Container
            id={'global-container'}
            sx={{
              mx: 0,
              px: 0,
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
            maxWidth={false}
            disableGutters={true}
          >
            <DevSiteBanner />
            <AppHeader toggleLeftNav={toggleLeftNav} />
            <ActivateUserModal />
            <LeftNav
              navOptions={props.navOptions}
              open={open}
              setOpen={setOpen}
            >
              {props.children}
            </LeftNav>
            <Footer />
          </Container>
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
